import Layout from "./layout";
import LayoutColumn from "./layout-column";
import LayoutRow from "./layout-row";
Layout.Column = LayoutColumn;
Layout.Row = LayoutRow;
export default Layout;
//# sourceMappingURL=index.js.map